import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import store, { persistor } from "./store";
import Theme from "components/template/Theme";
import Layout from "components/layout";
import history from "./history";
import "./locales";
import { v4 as uuidv4 } from "uuid";

import AlertTemplate from "./components/shared/AlertTemplate";
import { ConfigProvider } from "utils/hoc/ConfigProvider";
import CookieConsentBanner from "components/shared/CookieConsentBanner";

const environment = process.env.NODE_ENV;

const options = {
  // you can also just use 'bottom center'
  position: positions.TOP_RIGHT,
  timeout: 3000,
  offset: "30px",
  // you can also just use 'scale'
  transition: transitions.FADE,
  containerStyle: {
    marginTop: "2%",
    marginRight: "2%",
    zIndex: "1000",
  },
};

/**
 * Set enableMock(Default false) to true at configs/app.config.js
 * If you wish to enable mock api
 */

function App() {
  const setUserUniqueId = () => {
    if (!localStorage.getItem("SCT-ID")) {
      const uniqueId = uuidv4();
      localStorage.setItem("SCT-ID", uniqueId);
    }
  };

  const captureReferralCode = () => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref && !localStorage.getItem("tsv_ref_code")) {
      localStorage.setItem("tsv_ref_code", ref);
    }
  };

  useEffect(() => {
    setUserUniqueId();
    captureReferralCode();
  }, []);

  return (
    <Provider store={store}>
      <AlertProvider template={AlertTemplate} {...options}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter history={history}>
            <Theme>
              <ConfigProvider>
                <Layout />
                <CookieConsentBanner />
              </ConfigProvider>
            </Theme>
          </BrowserRouter>
        </PersistGate>
      </AlertProvider>
    </Provider>
  );
}

export default App;
